import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { amplitudeModule } from '@/modules/amplitude';
import {
  OnboardingOptionItem,
  OnboardingOptionsList,
} from '@/pages/Onboarding/components/List';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { OnboardingTitle } from '@/pages/Onboarding/components/Title';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { nextStepTimeout } from '@/pages/Onboarding/utils/nextStepTimeout';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataType } from '../../types';

import { OPTIONS } from './constants';
import './Familiarity.scss';

export const OnboardingReplikaFamiliarity: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Familiarity',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const familiarity = form.watch('familiarity');

  const handleSelect = (
    option: OnbOptionType<LayoutDataType['familiarity']>,
  ) => {
    userService.createOrUpdate({
      onboarding_data: {
        familiarity: option.title,
      },
    });
    nextStepTimeout(wizard.nextStep);
  };

  return (
    <OnboardingPage className="onboarding-familiarity">
      <OnboardingNavigation />

      <IonContent>
        <OnboardingTitle className="onboarding-familiarity__title">
          How familiar are you with AI technology?
        </OnboardingTitle>
        <OnboardingOptionsList>
          {OPTIONS.map((option) => (
            <OnboardingOptionItem
              checked={familiarity === option.id}
              control={form.control}
              option={option}
              name="familiarity"
              key={option.id}
              onChange={() => handleSelect(option)}
            />
          ))}
        </OnboardingOptionsList>
      </IonContent>
    </OnboardingPage>
  );
};
